import axiosInstance from "./AxiosInstance"

// upload
export const sendUploadFile = (path, id, data) => {
    const formData = new FormData()
    for (const k in data) {
        formData.append(k, data[k])
    }
    
    const config = {
        headers: {
            ...axiosInstance.defaults.headers,
            'content-type': 'multipart/form-data',
        },
    }

    if(id) {
        return axiosInstance.patch(path + "/" + id, formData, config)
    }
    
    return axiosInstance.post(path, formData, config)
}

// Realiza o download de um arquivo.
export const downloadUploadFile = (path, id) => {
    return axiosInstance.get(path + "/" + id, { responseType: 'arraybuffer' });
}